import { createContext } from 'react';

const LanguageContext = createContext({
    allowedLanguages: [],
    language: null,
    setLanguage: () => {},
});

export default LanguageContext;
